var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgencyDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.348 9.299a2.299 2.299 0 1 1-4.598 0 2.299 2.299 0 0 1 4.598 0zm7.304 0a2.299 2.299 0 1 0 4.598 0 2.299 2.299 0 0 0-4.598 0zM8 13c1.637 0 3.043.983 3.663 2.39L15 18.727l3.925-3.926C19.66 13.701 20.765 13 22 13c2.21 0 4 2.239 4 5v5h-2v-6h-1v6h-5v-4.728l-2.364 2.364a.9.9 0 0 1-1.273 0L12 18.273V23H7v-6H6v6H4v-6a4 4 0 0 1 4-4z",
    fill: "url(#4wpmmnfeha)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4wpmmnfeha",
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB62D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C82AEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgencyDark);
export default __webpack_public_path__ + "static/media/ic-agency-dark.06621f618138c08d20a8eb0d88643d09.svg";
export { ForwardRef as ReactComponent };